module.exports = __webpack_public_path__ + "img/rule-01-mobile.3fa80b28.png";